import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import {
  RiDashboardLine,
  RiLeafLine,
  RiTeamLine,
  RiUserHeartLine,
  RiChatSmile2Line,
  RiLogoutBoxRLine,
  RiScissorsCutLine,
  RiLightbulbFlashLine,
} from 'react-icons/ri';

const navLinks = [
  { to: '/', label: 'Tableau de bord', icon: RiDashboardLine, exact: true },
  { to: '/admin/catalogue', label: 'Catalogue', icon: RiLeafLine },
  { to: '/admin/problematiques', label: 'Problématiques', icon: RiLightbulbFlashLine },
  { to: '/admin/employes', label: 'Employés', icon: RiTeamLine },
  { to: '/admin/clients', label: 'Clientes', icon: RiUserHeartLine },
  { to: '/admin/feedbacks', label: 'Retours', icon: RiChatSmile2Line },
];

const Sidebar: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <aside className="fixed top-0 left-0 h-full w-60 bg-white border-r border-gray-100 flex flex-col z-40 shadow-sm">
      {/* Logo */}
      <div className="flex items-center gap-3 px-6 py-5 border-b border-gray-100">
        <div className="w-9 h-9 rounded-xl bg-brand-500 flex items-center justify-center flex-shrink-0">
          <RiScissorsCutLine className="text-white text-lg" />
        </div>
        <div className="leading-tight">
          <p className="font-bold text-gray-900 text-sm">Patience Plus</p>
          <p className="text-xs text-brand-500 font-medium">Administration</p>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {navLinks.map(({ to, label, icon: Icon, exact }) => (
          <NavLink
            key={to}
            to={to}
            end={exact}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-brand-50 text-brand-600'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon className={`text-lg flex-shrink-0 ${isActive ? 'text-brand-500' : 'text-gray-400'}`} />
                {label}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="px-3 py-4 border-t border-gray-100">
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 hover:bg-red-50 hover:text-red-600 transition-colors"
        >
          <RiLogoutBoxRLine className="text-lg text-gray-400" />
          Déconnexion
        </button>
      </div>
    </aside>
  );
};

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';

  if (isLoginPage) {
    return <>{children}</>;
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className="ml-60 flex-1 flex flex-col min-h-screen">
        <main className="flex-1 p-8">
          {children}
        </main>
        <footer className="px-8 py-4 border-t border-gray-100 bg-white">
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} Soin Capillaire Patience Plus — Tous droits réservés.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default Layout;
